



































import { Component, Prop, Vue } from "vue-property-decorator";
//  utilities
import dateHelper from "Utilities/date-helper";
import moment from "moment";
//  types
import { IndicatorData } from "@/types/dataQuality/dataQualityTable";

@Component({})
export default class DataIndicator extends Vue {
  @Prop({ type: Object }) data!: IndicatorData;

  onIndicatorClicked(): void {
    this.$emit("onIndicatorClicked", this.data);
  }
  //  @Getters
  get isNotAvailable(): boolean {
    return this.data.status === 0;
  }

  get statusColor() {
    if (!this.data) return;
    switch (this.data.status) {
      case 1:
        return "ContentPositivePrimary";
      case 2:
        return "ContentWarningSecondary";
      case 3:
        return "ContentNegativePrimary";
      default:
        return "ContentTertiary";
    }
  }

  //  @Methods
  navigateToLink(): void {
    if (!this.data.link) throw new Error("Link is undefined");
    this.$router.push(this.data.link);
  }

  getFormatedDateTimeString(timestamp: string): string {
    return dateHelper.getFormatedDateTimeString(timestamp);
  }

  duration(timestamp: string): string {
    return dateHelper.getHumanizeDuration(timestamp, moment().valueOf());
  }
}
